// Licensed under the MIT license.

export enum GrantType {
  authCode = "authorization_code",
  ssoToken = "sso_token"
}
